import React from "react";
import styles from "./ProductSkeleton.module.css";

const ProductSkeleton: React.FC = () => {
  return (
    <div className="container">
      <div className={styles.product}>
        {/* Product Image Section */}
        <div className={styles.productImage}>
          <div className={styles.mainImageContainer}>
            <div className={styles.mainImageSkeleton}></div>
          </div>
          <div className={styles.thumbnails}>
            {[...Array(4)].map((_, index) => (
              <div key={index} className={styles.thumbnailSkeleton}></div>
            ))}
          </div>
        </div>

        {/* Product Info Section */}
        <div className={styles.productInfo}>
          <div className={styles.brandSkeleton}></div>
          <div className={styles.nameSkeleton}></div>
          <div className={styles.priceSkeleton}></div>
          <div className={styles.descriptionSkeleton}></div>

          {/* Grouping Attributes Skeleton */}
          {[...Array(2)].map((_, index) => (
            <div key={index} className={styles.attribute}>
              <div className={styles.attributeHeaderSkeleton}></div>
              <div className={styles.swatchesSkeleton}>
                {[...Array(4)].map((_, idx) => (
                  <div key={idx} className={styles.swatchSkeleton}></div>
                ))}
              </div>
            </div>
          ))}

          {/* Customizable Options Skeleton */}
          <div className={styles.customizableOptionsSkeleton}>
            <div className={styles.optionTitleSkeleton}></div>
            <div className={styles.optionContentSkeleton}></div>
          </div>

          {/* Delivery Section */}
          <div className={styles.deliverySkeleton}></div>

          {/* Stock Availability */}
          <div className={styles.stockSkeleton}></div>

          {/* Add to Cart Section */}
          <div className={styles.addToCartSkeleton}>
            <div className={styles.quantitySkeleton}></div>
            <div className={styles.buttonSkeleton}></div>
          </div>
        </div>
      </div>

      {/* Product Attributes Grid Skeleton */}
      <div className={styles.attributesTableSkeleton}>
        <div className={styles.tableTitleSkeleton}></div>
        <div className={styles.tableRowsSkeleton}>
          {[...Array(5)].map((_, index) => (
            <div key={index} className={styles.tableRowSkeleton}></div>
          ))}
        </div>
      </div>

      {/* Recommended Products Skeleton */}
      <section
        className={styles.recommendedSectionSkeleton}
        aria-label="Tal vez buscas... productos recomendados"
      >
        <div className={styles.recommendedHeaderSkeleton}>
          <div className={styles.recommendedTitleSkeleton}></div>
        </div>
        <div
          className={styles.recommendedSliderSkeleton}
          role="region"
          aria-label="Productos recomendados"
        >
          {[...Array(4)].map((_, idx) => (
            <div key={idx} className={styles.recommendedProductCardSkeleton}>
              <div className={styles.recommendedImageSkeleton}></div>
              <div className={styles.recommendedNameSkeleton}></div>
              <div className={styles.recommendedPriceSkeleton}></div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ProductSkeleton;
